import { Fragment } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useCheckoutTabContext } from "../CheckoutTabContext";
import { BuilderSidebar } from "../components/BuilderSidebar";
import { PROPERTIES, localeRoot } from "../constants";
import { CountdownProperties } from "./CountdownProperties";
import { DefaultProperties } from "./DefaultProperties";
import { PriceCalloutProperties } from "./PriceCalloutProperties";
import { BadgeProperties } from "./Properties/BadgeProperties";
import { BenefitProperties } from "./Properties/BenefitProperties";
import { TestimonialProperties } from "./Properties/TestimonialProperties";
import { ReducedPriceProperties } from "./ReducedPriceProperties";
import { Header } from "./components/Header";

export const Sidebar = () => {
  const { goBack, history, currentSidebar } = useCheckoutTabContext();

  const sidebarContentMapping = {
    [PROPERTIES.DEFAULT]: [
      DefaultProperties,
      t([localeRoot, "builder.default.title"]),
    ],
    [PROPERTIES.TESTIMONIALS]: [
      TestimonialProperties,
      t([localeRoot, "builder.testimonials.title"]),
    ],
    [PROPERTIES.BADGES]: [
      BadgeProperties,
      t([localeRoot, "builder.badges.title"]),
    ],
    [PROPERTIES.BENEFITS]: [
      BenefitProperties,
      t([localeRoot, "builder.benefits.title"]),
    ],
    [PROPERTIES.COUNTDOWN]: [
      CountdownProperties,
      t([localeRoot, "builder.countdown.title"]),
    ],
    [PROPERTIES.PRICE_CALLOUTS]: [
      PriceCalloutProperties,
      t([localeRoot, "builder.price_callouts.title"]),
    ],
    [PROPERTIES.REDUCED_PRICES]: [
      ReducedPriceProperties,
      t([localeRoot, "builder.reduced_prices.title"]),
    ],
  } as const;

  const [SidebarContent, title] = sidebarContentMapping[currentSidebar] || [
    Fragment,
    "",
  ];

  return (
    <BuilderSidebar className="flex w-[328px] flex-col">
      <Header className="gap-x-3.5">
        {history.length > 1 && (
          <Button onClick={goBack} variant="circle-text" className="text-dark">
            <Icon type="24-arrow-left" />
          </Button>
        )}
        <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
      </Header>
      <SidebarContent />
    </BuilderSidebar>
  );
};
